import { RootState } from 'store';
import ReportingResult from 'types/reporting/ReportingResult';

export const reportDataSelector = (state: RootState): ReportingResult => state.reporting;

export const reportErrorSelector = (state: RootState): boolean => state.reporting.error;
